<it-icon
    [icon]="IconEnum.SPINNER"
    [spin]="true"
    [color]="color"
    [fontSize]="fontSize"
/>
